module.exports = __webpack_public_path__ + "img/STEP3.3b6e3f5e.png";